import React, { useContext } from 'react';
import classnames from 'classnames';
import SimpleBiButton from '../../../biLogger/Components/SimpleBiButton';
import BiLink from '../../../biLogger/Components/BiLink';
import { MobileContext } from '../../../Context';
import PopoverWithTooltip from '../PopoverWithTooltip';
import s from './ActionBarButton.scss';
function wrapInTooltip(children, tooltip, renderPopover) {
    if (renderPopover || tooltip) {
        return (React.createElement(PopoverWithTooltip, { tooltip: tooltip, renderPopover: renderPopover, positionOnly: true, showArrow: false, allowMobile: true }, children));
    }
    return React.createElement(React.Fragment, null, children);
}
var ActionBarButton = function (_a) {
    var href = _a.href, children = _a.children, onClick = _a.onClick, dataHook = _a.dataHook, tooltip = _a.tooltip, renderPopover = _a.renderPopover, biData = _a.biData, isDownload = _a.isDownload, isDisabled = _a.isDisabled, isEditAction = _a.isEditAction, allowMobilePopover = _a.allowMobilePopover;
    var isMobile = useContext(MobileContext);
    var className = classnames(s['root'], isEditAction && s['edit']);
    var wrap = function (node) {
        return isMobile && !allowMobilePopover ? (React.createElement(React.Fragment, null, node)) : (wrapInTooltip(node, tooltip, renderPopover));
    };
    if (href) {
        if (isDisabled) {
            return wrap(React.createElement("span", { className: className }, children));
        }
        return wrap(React.createElement(BiLink, { href: href, onClick: onClick, biData: biData, "data-hook": dataHook, download: isDownload, target: isDownload ? '_blank' : undefined, className: className }, children));
    }
    return wrap(React.createElement(SimpleBiButton, { className: className, onClick: onClick, biData: biData, disabled: isDisabled, "data-hook": dataHook }, children));
};
ActionBarButton.displayName = 'ActionBarButton';
export default ActionBarButton;
//# sourceMappingURL=ActionBarButton.js.map